import { render, staticRenderFns } from "./NavMainIcon.vue?vue&type=template&id=9d3676cc&"
import script from "./NavMainIcon.vue?vue&type=script&lang=js&"
export * from "./NavMainIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports